import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Container, Button } from '@mui/material';

import { ICustomerDetails } from "../../../types/customer";

import { useListContext } from "../../../contexts/listContext";
import { useUserContext } from "../../../contexts/userContext";

import PermissionGate from "../../permissionGate";
import Navigation from "../../header";
import CustomerDetailsForm from "../../forms/customerDetailsForm";
import { Icons } from "../../icons";
import { IReportRegistration } from "../../../types/report";
import ReportRegistrationDetailsForm from "../../forms/reportRegistrationDetailsForm";

const ReportRegistrationAdd = () => {
	const userContext = useUserContext();
	const listContext = useListContext();

	const [formFields, setFormFields] = useState<IReportRegistration>({
		displayName: "",
		name: "",
		reportId: "",
		workspaceId: "",
		type: "pbi",
		active: true,
		ordinal: 1,
		permission: ""
	});

	const reset = async () => {
		setFormFields({
			displayName: "",
			name: "",
			reportId: "",
			workspaceId: "",
			type: "pbi",
			active: true,
			ordinal: 1,
			permission: ""
		});
	}

	return (
		<div className="hwi-report-registration-add">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageReportRegistrations}>
					<section className="management-page-header">
						<div className="title">
							<NavLink to="/report/registration">
								<Icons.GoBack fill="#9399ad" height="24px"></Icons.GoBack>
							</NavLink>
							Register New Report
						</div>
					</section>
					<section className="management-page-form">
						<ReportRegistrationDetailsForm action="add" details={formFields}></ReportRegistrationDetailsForm>
					</section>
				</PermissionGate>
			</Container>
		</div>
	);
};

export default ReportRegistrationAdd;